import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { FuaFormData } from 'components/Assessments/FuaAssessment/types/FuaFormData'
import { FuaAssessmentQuestionnaireItem } from 'components/Assessments/FuaAssessment/types/questionnaire'
import { FinalStepsFormField } from './formField'

/**
 * Final Steps subsection adapter for FUA Assessment
 * Handles final-steps extraction and transformation
 */
export class FinalStepsAdapter extends BaseSubsectionAdapter<FuaFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<FuaFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const finalStepsInternalNotes = getAnswerValuesFromItems(
      flatAnswersArray,
      FuaAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES
    )?.at(0)
    const pendingRequiredDocumentation =
      getAnswerValuesFromItems(
        flatAnswersArray,
        FuaAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION
      ) || []

    return {
      [FinalStepsFormField.FINAL_STEPS_INTERNAL_NOTES]: finalStepsInternalNotes,
      [FinalStepsFormField.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION]: pendingRequiredDocumentation
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(FinalStepsFormField.FINAL_STEPS_INTERNAL_NOTES)) {
      mutations.push({
        linkId: FuaAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES,
        value: this.getFormDataField(FinalStepsFormField.FINAL_STEPS_INTERNAL_NOTES)
      })
    }

    if (this.formDataFieldExists(FinalStepsFormField.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION)) {
      mutations.push({
        linkId: FuaAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION,
        value: this.getFormDataField(FinalStepsFormField.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION)
      })
    }

    return mutations
  }
}
